/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type CreatedOnCell_ConfigurationFragment = { __typename: 'ConfigurationModel', id: string, createdAt: any };

export const CreatedOnCell_ConfigurationFragmentDoc = gql`
    fragment CreatedOnCell_configuration on ConfigurationModel {
  id
  createdAt
}
    `;